// Components
import { Link, Pill } from '@tracklib/kit'
import { MiniSong, ShadowBox } from 'kit'
import ActionButton from 'components/usersongs/song/actionbutton'
import ProgressBar from 'components/usersongs/song/progress'
import ReportInfo from 'components/usersongs/song/reportinfo'
import Status from 'components/usersongs/song/status'
import Dropdown from 'components/usersong/dropdown'

// Selectors
import { selectUserSongSteps } from 'modules/usersongs/selectors'

// Types
import { UserSong as UserSongType, Song } from 'types'

import styles from './index.css'

type UserSongProps = {
  userSong: UserSongType
}

const UserSong = ({ userSong }: UserSongProps): JSX.Element => {
  const steps = selectUserSongSteps(userSong)
  const { state, samples, id } = userSong
  const isUnlicensed = state === 'UNLICENSED'

  return (
    <li className={styles.wrapper} datatesting="usersong_item">
      <ShadowBox className={styles.box}>
        <div className={styles.info}>
          <Link to={`/yoursongs/${userSong.id}/${isUnlicensed ? 'sample' : 'license'}/`}>
            <header>
              <h2 className={styles.title}>{userSong.song_title}</h2>
              <Status status={state} size="small" />
            </header>
          </Link>
          <Dropdown userSongId={id} className={styles.contextMenu} isUnlicensed={isUnlicensed} userSongState={userSong.state} />
          <Link to={`/yoursongs/${userSong.id}/${isUnlicensed ? 'sample' : 'license'}/`}>
            <Pill size="small">Original song sampled</Pill>
            {samples.map(sample => (
              <MiniSong song={sample.song as Song} className={styles.songWrapper} key={sample.id} />
            ))}
          </Link>
        </div>

        <div className={styles.action}>
          <div>
            {state === 'INCOMPLETE' && <ProgressBar steps={steps} />}
            {state === 'ACTIVE' && <ReportInfo userSong={userSong} />}
          </div>
          <ActionButton userSong={userSong} steps={steps} />
        </div>
      </ShadowBox>
    </li>
  )
}

export default UserSong
